// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ii-0";
export var assigneeDetails = "_ii-1";
export var assigneeInfo = "_ii-2";
export var dropdownContainer = "_ii-4";
export var dropdownImage = "_ii-5";
export var editAssigneeInfo = "_ii-3";
export var editAssigneeModalContainer = "_ii-6";
export var hidden = "_ii-8";
export var input = "_ii-7";